import React, { useCallback, useState } from 'react';
import axios from '../modules/api';
import http from '../modules/api';
import * as StyleUtil from '../modules/utils/StyleUtil';
import * as StringUtil from '../modules/utils/StringUtil';
import {Line} from 'react-chartjs-2';
import { NavLink, Link, Prompt } from 'react-router-dom';
import { SketchPicker } from 'react-color';
import $ from 'jquery';
import Slider from "react-slick";
import download_img from '../../resources/img/download.svg';
import btn_arrow_up_img from '../../resources/img/btn_arrow_up.svg';
import btn_arrow_down_img from '../../resources/img/btn_arrow_down.svg';

import FileDownload from 'js-file-download';

import GA4React from "ga-4-react";

try {
    setTimeout(_ => {
      const ga4react = new GA4React("G-EBVEYNW6SX");
      ga4react.initialize().catch(err => console.error("ga4react"+err));
    }, 4000);
} catch (err) {
    console.error("ga4react",err);
}

var object_domain = document.domain.indexOf("robomd.io") > -1 ? "https://script.robomd.io" : "https://"+document.domain;
var object_port = window.location.port;
if (document.domain.indexOf("127.0.0.1") >= 0 && object_port == "3000") {
    object_domain = "http://127.0.0.1:8092"
} else if (object_port != '') {
    object_domain = object_domain + ":" + object_port
}
var textareaTimer = {}; // textarea 입력 작업시 여러번 요청 보내는 것을 방지

export class Sosanggongin2 extends React.Component {
    constructor(props) {
		super(props);
		this.state = {
            // 인증 정보
            pwd : "",
            kdeal_secure_product_token : "",

            // 상품 정보
            tmp_product_no : "",
            product_no : "",
            product_name : "",
            kdeal_user_no: "",
           
            event_list : [],
           
            tmp_event_list: [],
            tmp_event_seq_list : [],
            template_form_list: [],
            displayColorPicker : {},

            parent_event_type_cd : "",

            is_downloaded: true,
        }
    }

    componentWillMount() {
        
    }

	componentDidMount() {
        this.loadKdealShopList();
        this.loadKdealCommonCode("01000");

        // 주소에 product_no 정보가 있다면, 값을 저장
        const product_no = StringUtil.getUrlParams("product_no");
        if(product_no != null && product_no != ""){
            this.setState({
                product_no : product_no
            });
        }

        $(document).ready(function(){
            $("#palleteBack").hide();
            setTimeout(() => window.dispatchEvent(new Event('resize')), 10);
        });

        $(window).resize(function(){
            $("#sosang_page_area").css('height',window.innerHeight);
            $("#footer").css('width',$("#admin_wrap").width());
            $("#footer_line").css('width',$("#admin_wrap").width());
        });
        
        // 사이드바 확장/축소 버튼 클릭 시 화면 비율 조정
        $('html').click(function(e) {
            if($(e.target).hasClass("cursor-pointer") || $(e.target).parents(".cursor-pointer").length > 0) {
                setTimeout(() => window.dispatchEvent(new Event('resize')), 10);
            }
        });
        
    }

    componentDidUpdate() {
        let product_no = this.state.product_no;
        let parent_event_type_cd = this.state.parent_event_type_cd;
        let kdeal_secure_product_token = this.state.kdeal_secure_product_token;
        $(window).resize(function(){
            // 새로 생성하는 페이지인데 템플릿이 선택되지 않았거나, 불러온 페이지인데 토큰을 받지 못한경우
            if(((product_no == null || product_no == "") && parent_event_type_cd == "") || ((product_no != null && product_no != "") && kdeal_secure_product_token == "")){
                // event_list를 불러오지 않기 때문에 짧은 상태로 존재하는 page_area의 높이를 윈도우 높이만큼 늘려준다.(배경색이 끊기는 듯한 현상 방지)
                $("#sosang_page_area").css('height',window.innerHeight);
            } else{
                $("#sosang_page_area").css('height',"");
            }
            $("#footer").css('width',$("#admin_wrap").width());
            $("#footer_line").css('width',$("#admin_wrap").width());
        });

        //console.log(this.state.template_form_list);
        //console.log(this.state.tmp_event_seq_list)
        //console.log(this.state.event_list);
        //console.log(this.state.pwd);
        //console.log(this.state.tmp_event_list);
        //console.log(this.state.intro_first_line);
        // console.log(this.state.intro_second_line);
        // console.log(this.state.intro_third_line);

        // console.log(this.state.intro_image);
        // console.log(this.state.detail_one_image);
        // console.log(this.state.detail_two_image);
        // console.log(this.state.detail_three_image);
        // console.log(this.state.detail_info_image);

    }

    componentWillUnmount(e) {

    }

    // 비밀번호 체크 및 상품용 토큰 발급
    checkPassword(){
        const config = {
            headers: {
                'content-type': 'application/json;'
            },
        }
        const body = {
            pwd : this.state.pwd,
            product_no : this.state.product_no,
            tmp_product_no : this.state.tmp_product_no,
            kdeal_user_no : this.state.kdeal_user_no
        }
        http.post("/rest/common/kdeal/secure/product/password",
            body,
            config
        )
        .then(res => {
            //console.log(res.data);
            if(res.data.code != "200"){
                alert(res.data.msg);
            } else{
                this.setState({
                    kdeal_secure_product_token : res.data.kdeal_secure_product_token
                }, () => {
                    // 토큰을 받았다면 업체명, 템플릿, 비밀번호 비활성화
                    // $("#kdeal_user_no").prop('disabled',true);
                    $("#kdeal_user_nane").prop('disabled',true);
                    // $("#kdeal_user_no").css({background:"#F3F3F3", cursor:"default"});
                    $("#kdeal_user_nane").css({background:"#F3F3F3", cursor:"default", color:"#afafaf"});
                    $("#parent_event_type_cd").prop('disabled',true);
                    $("#parent_event_type_cd").css({background:"#F3F3F3", cursor:"default"});
                    $("#input_password").prop('disabled',true);
                    $("#input_password").css({background:"#F3F3F3", cursor:"default", color:"#b7bdC3"});

                    // 저장된 이벤트 목록 불러오기
                    this.loadProduct();
                });
            }
        })
        .catch(error => {
        });
    }

    // 템플릿 목록 조회
    async loadKdealCommonCode(upper_code_cd){
        await http.get("/rest/common/kdeal/commonCode?upper_code_cd="+upper_code_cd)
        .then(res => {
            if (upper_code_cd == "01000") {
                this.setState({
                    template_code_list:  res.data
                })
            }
        })
        .catch(error => {
        });
    }

    // 소상공인 업체 목록 데이터 불러오기
    async loadKdealShopList() {
        await http.get("/rest/common/kdeal/user/list")
		.then(res => {
            //console.log(res.data);
			if (res.data != null && res.data != '') {
				this.setState({
                    shop_list : res.data,
                });
			}
		})
		.catch(error => {
		 });
    }

    // 선택한 템플릿 이벤트 개수 불러오기
    async loadBasicEventCnt(type) {
        await http.get("/rest/common/kdeal/template/form/cnt?parent_event_type_cd="+this.state.parent_event_type_cd)
		.then(res => {
            //console.log(res.data);
			if (res.data != null && res.data != '') {
                if(type=="first_change"){
                    // tmp_product_no가 없는 경우에만, 템플릿을 새로 불러온것으로 처리하기 때문에
                    // ""으로 만들어준 후 tmp_event_seq_list를 불러온다.
                    this.setState({
                        tmp_product_no : ""
                    }, () => {
                        this.loadTmpEventSeqList(res.data["total_form_cnt"],null,"first_change");
                    })
                } else if(type=="loadProduct"){
                    // 기존 상품 이벤트 리스트랑 템플릿 이벤트 리스트의 개수를 합쳐서 tmp_seq를 다시 불러온다.
                    // 여러가지 디자인을 다 지워버리고 한 종류로 엄청 만들었을 경우, 다시 불러올때는 사라진 디자인들을 띄워야하는데,
                    // 그 개수 차이를 loadDesignTemplate쪽에서 구할수있지만, loadDesignTemplate를 실행하기 전에 tmp_event_seq_list를 받아와야 해서
                    // 순서가 꼬이고 미리 받아올 수 없어서 디자인 템플릿 이벤트 개수만큼 넉넉하게 받아온다.
                    this.setState({
                        tmp_product_no : ""
                    }, () => {
                        this.loadTmpEventSeqList(Number(res.data["total_form_cnt"])+this.state.event_list.length,null,"loadProduct");
                    });
                }
			}
		})
		.catch(error => {
		 });
    }

    // 디자인 템플릿 폼 영역 조회
    async loadDesignTemplate(type){
        setTimeout(() => window.dispatchEvent(new Event('resize')), 10);

        if (this.state.parent_event_type_cd == "") {
            return false;
        }
        await http.get("/rest/common/kdeal/designTemplate/v2?parent_event_type_cd="+this.state.parent_event_type_cd)
        .then(res => {
            let event_list = [];
            let template_form_list = res.data["list"];
            // 불러온 템플릿 디자인에 맞게 event를 추가한다
            if (type == "first_change") {
                for(let idx in template_form_list) {
                    for(let idx2=0; idx2 < template_form_list[idx].form_cnt; idx2++) {
                        let content_list = [];
                        let contentDesignTemplateList = template_form_list[idx]["contentDesignTemplateList"];
                        for (let cd_idx = 0; cd_idx < contentDesignTemplateList.length; cd_idx++) {
                            if(contentDesignTemplateList[cd_idx].content_type_cd == "44001"){
                                content_list.push({
                                    contents : "",
                                    content_seq : null,
                                    font_color: contentDesignTemplateList[cd_idx].text_color,
                                    content_type_cd: contentDesignTemplateList[cd_idx].content_type_cd,
                                    content_title_cd : contentDesignTemplateList[cd_idx].content_title_cd,
                                });
                            } else if(contentDesignTemplateList[cd_idx].content_type_cd == "44002"){
                                content_list.push({
                                    kdeal_org_img_seq : null,
                                    img_name: null,
                                    content_seq : null,
                                    content_type_cd: contentDesignTemplateList[cd_idx].content_type_cd,
                                    content_title_cd : contentDesignTemplateList[cd_idx].content_title_cd,
                                });
                            }
                            
                        }
                        event_list.push(
                            {
                                form_type_cd : template_form_list[idx].form_type_cd,
                                event_type_cd: template_form_list[idx].event_type_cd,
                                event_seq : null,
                                background_color: template_form_list[idx].background_color,
                                content_list: content_list
                            }
                        )
                    }
                }
            } else { /* 저장된 정보를 불러오는 경우 */
                event_list = this.state.event_list;

                // 디자인 템플릿과 불러온 데이터를 비교하여, 각 디자인의 event 개수가 디자인 템플릿의 event 개수보다 적을경우, 부족한 만큼 이벤트를 추가하는 작업을 진행한다.
                // 템플릿을 모두 조회하여 작업을 진행한다.
                for(let i=0;i<template_form_list.length;i++){
                    let template_form_type_cd = template_form_list[i].form_type_cd;
                    let template_event_type_cd = template_form_list[i].event_type_cd;
                    let template_form_cnt = template_form_list[i].form_cnt;
                    let event_form_cnt = 0;
                    for(let idx=0;idx<event_list.length;idx++){
                        // 해당 템플릿과 form_type_cd 및 event_type_cd가 동일한(디자인이 같은) 이벤트의 개수를 센다.
                        if(event_list[idx].form_type_cd == template_form_type_cd && event_list[idx].event_type_cd == template_event_type_cd){
                            event_form_cnt ++;
                        }
                    }
                    // 저장된 이벤트 개수가 기존 템플릿 수보다 작다면, 부족한 만큼 이벤트를 추가
                    if(template_form_cnt-event_form_cnt > 0){
                        let event_num = 0;
                        for(let idx=0;idx<event_list.length;idx++){
                            if(event_list[idx].form_type_cd == template_form_type_cd){
                                event_num = idx;
                            }
                        }
                        for(let idx=0;idx<template_form_cnt-event_form_cnt;idx++){
                            let content_list = [];
                            let contentDesignTemplateList = template_form_list[i]["contentDesignTemplateList"];
                            for (let cd_idx = 0; cd_idx < contentDesignTemplateList.length; cd_idx++) {
                                if(contentDesignTemplateList[cd_idx].content_type_cd == "44001"){
                                    content_list.push({
                                        contents : "",
                                        content_seq : null,
                                        content_type_cd: contentDesignTemplateList[cd_idx].content_type_cd,
                                        font_color: contentDesignTemplateList[cd_idx].text_color,
                                        content_title_cd : contentDesignTemplateList[cd_idx].content_title_cd
                                    });
                                } else if(contentDesignTemplateList[cd_idx].content_type_cd == "44002"){
                                    content_list.push({
                                        kdeal_org_img_seq : null,
                                        img_name: null,
                                        content_seq : null,
                                        content_type_cd: contentDesignTemplateList[cd_idx].content_type_cd,
                                        content_title_cd : contentDesignTemplateList[cd_idx].content_title_cd,
                                    });
                                }
                            }
                            event_list.push(
                                {
                                    form_type_cd : template_form_list[i].form_type_cd,
                                    event_type_cd: template_form_list[i].event_type_cd,
                                    event_seq : null,
                                    background_color: template_form_list[i].background_color,
                                    content_list: content_list
                                }
                            )
                        }
                    }
                    // 저장된 이벤트 개수가 기존 템플릿 수보다 많다면, 템플릿 form_cnt를 늘린다
                    else if(template_form_cnt-event_form_cnt < 0){
                        template_form_list[i].form_cnt = event_form_cnt;
                    }
                }
            }
            
            // 각 form_type_cd의 event 개수를 세어 form_total_cnt에 넣는다
            let form_type_cd_list = [];
            for(let i=0;i<template_form_list.length;i++){
                form_type_cd_list.push(template_form_list[i].form_type_cd);
            }
            const set = new Set(form_type_cd_list);
            form_type_cd_list = [...set];
            // form_type_cd 마다 form_cnt를 합친다
            for(let i=0;i<form_type_cd_list.length;i++){
                let form_total_cnt = 0;
                for(let idx=0;idx<template_form_list.length;idx++){
                    if(template_form_list[idx].form_type_cd == form_type_cd_list[i]){
                        form_total_cnt += template_form_list[idx]["form_cnt"];
                    }
                }
                for(let idx=0;idx<template_form_list.length;idx++){
                    if(template_form_list[idx].form_type_cd == form_type_cd_list[i]){
                        template_form_list[idx]["form_total_cnt"] = form_total_cnt;
                    }
                }
            }

            // 이벤트에 tmp_event_seq를 추가한다
            for(var idx in event_list) {
                event_list[idx].tmp_event_seq  = this.state.tmp_event_seq_list[idx];
            }
            let tmp_event_list = JSON.parse(JSON.stringify(event_list));
             // 저장되었던 상품이라면 tmp_event_list의 content_seq 초기화(맨 처음 미리보기 데이터 저장시, tmp_event_list의 content_seq는 null로 보내져야함)
            if(this.state.product_no != null && this.state.product_no != ""){
                for(let idx in tmp_event_list){
                    for(let idx2 in tmp_event_list[idx]["content_list"]){
                        tmp_event_list[idx]["content_list"][idx2].content_seq = null
                    }
                }
            }
            this.setState({
                template_form_list: template_form_list,
                event_list: JSON.parse(JSON.stringify(event_list)),
                tmp_event_list: tmp_event_list,
            }, () => {
                for (let idx in this.state.tmp_event_list) {
                    this.onChangeEventFormContent(idx); // 미리보기 데이터 저장
                }

                // blur를 강제로 주어, textarea 영역 크기와 맞게 오른쪽 영역도 변동되도록 한다 (blur에 달려있는 함수 실행)
                let window_scrollTop = $(window).scrollTop();
                for (let idx in this.state.event_list) {
                    let content_list = this.state.event_list[idx].content_list;

                    for (let i=1; i<=content_list.length; i++) {
                        $("#"+this.state.tmp_event_list[idx].tmp_event_seq+"_"+i+"_textarea").focus();
                        $("#"+this.state.tmp_event_list[idx].tmp_event_seq+"_"+i+"_textarea").blur();
                    }
                }
                // 초기의 스크롤 위치로 스크롤 이동
                $("html,body").scrollTop(window_scrollTop);
            })
        })
        .catch(error => {
        });
    }

    // 기존 상품 이벤트 개수 불러오기 (현재 사용되지 않음)
    async loadProductEventCnt(){
        
        await http.get("/rest/common/kdeal/product/event/cnt?product_no="+this.state.product_no)
        .then(res => {
            //console.log(res.data);
            if (res.data != null && res.data != '') {

            }
        })
        .catch(error => {
            });
    }

    // 기존 상세페이지 정보 불러오기
    async loadProduct(){
        await http.get("/rest/common/kdeal/product?product_no="+this.state.product_no+"&kdeal_secure_product_token="+this.state.kdeal_secure_product_token)
            .then(res => {
                //console.log(res.data);
                if (res.data != null && res.data != '') {
                    let tmp_event_list = [...res.data["event_list"]]
                    for(var idx in tmp_event_list) {
                        tmp_event_list[idx].tmp_event_seq = this.state.tmp_event_seq_list[idx]
                    }

                    this.setState({
                        event_list: res.data["event_list"],
                        product_name: res.data.product_name,
                        parent_event_type_cd: res.data.parent_event_type_cd, 
                        kdeal_user_no: res.data.kdeal_user_no,
                        tmp_event_list: tmp_event_list
                    }, () => {
                        this.loadBasicEventCnt("loadProduct");

                        // kdeal_user_no로 kdeal_user_name 알아내기
                        let kdeal_user_obj = this.state.shop_list.filter(obj => obj.user_no == this.state.kdeal_user_no)
                        let kdeal_user_name = ""
                        if (kdeal_user_obj.length > 0) {
                            kdeal_user_name = kdeal_user_obj[0].corp_name_reg_no
                        } else {
                            kdeal_user_name = ""
                        }
                        this.setState({
                            kdeal_user_name: kdeal_user_name,
                        }, () => {
                            // alert(this.state.kdeal_user_no);
                        })
                    })
                }
            })
            .catch(error => {
             });
    }

    // 소상공인 미리보기용 이벤트 생성
    loadTmpEventSeqList(event_num, event_type_cd, type){
        const config = {
            headers: {
                'Content-Type': 'application/json',
                },
        };
        const url = '/rest/common/kdeal/first/event/tmp/save';
        let body = {};
        // event_num의 개수만큼 tmp_event_seq를 발급받는다
        // +버튼을 누른 경우에는 1개를 발급받는다 (이미 tmp_event_seq_list를 발급 받은 경우 +버튼을 누른 것)
        body = {
            event_cnt : this.state.tmp_product_no != ""? "1" : event_num,
            product_no : this.state.tmp_product_no != ""? this.state.tmp_product_no : null,
        }
        http
        .post(url, body, config)
		.then(res => {
            //console.log(res.data);
			if (res.data != null && res.data != '') {
                if(this.state.tmp_product_no == ""){
                    // 새로 들어온 생성한 페이지, 상품 이벤트 목록을 불러왔을 경우, 템플릿을 변경한 경우 등은
                    // tmp_event_seq_list를 갈아끼운다
                    this.setState({
                        tmp_event_seq_list : res.data["tmp_event_seq_list"],
                        tmp_product_no : res.data["product_no"],
                    }, () => {
                        if(type=="loadProduct"){
                            this.loadDesignTemplate();
                        } // 템플릿을 선택했을 경우(변경했을 경우)
                        else if(type == "first_change"){
                            this.loadDesignTemplate("first_change");
                        }
                    });
                } else{
                    // +버튼을 눌러, 새로운 tmp_event_seq를 발급받은 경우, 발급받은 seq를 기존 리스트에 위치에 맞게 추가한다
                    let {tmp_event_seq_list} = this.state;
                    tmp_event_seq_list.splice(event_num+1, 0, res.data["tmp_event_seq_list"][0]);
                    this.setState({
                        tmp_event_seq_list: tmp_event_seq_list
                    }, () => {
                        if(type == "plus"){
                            this.EventNumChange(event_num, event_type_cd, type);
                        }
                    });
                }
			}
		})
		.catch(error => {
		 });
    }

    // 템플릿 변경
    changeTemplate(e){
        if (this.state.parent_event_type_cd!="" && !window.confirm("템플릿을 변경 하시면 입력한 내용이 모두 지워집니다. 변경 하시겠습니까?")) {
            return false;
        }
        this.setState({
            event_list : [],
            tmp_event_list : [],
            template_form_list : [],
            parent_event_type_cd: e.target.value
        }, () => {
            this.loadBasicEventCnt("first_change");
        })
    }

    // 소상공인 이미지 업로드
    uploadOrgImg(file, event_idx, content_idx, image_id){
        const files = Array.from(file);
        Promise.all(files.map(file => {
            return (new Promise((resolve,reject) => {
                const reader = new FileReader();
                reader.addEventListener('load', (ev) => {
                    resolve(ev.target.result);
                });
                reader.addEventListener('error', reject);
                reader.readAsDataURL(file);
            }));
        }))
        .then(images => {
            const formData = new FormData();
            formData.append("files", files[0]);
            //console.log(formData);
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    },
            };
            const url = '/rest/common/kdeal/save/orgImg?kdeal_secure_product_token='+this.state.kdeal_secure_product_token+'&product_no=-1';
            http
            .post(url, formData, config)
            .then(res => {
                //console.log(res.data);
                // 이미지가 추가된 정보를 event_list, tmp_event_list 모두에 추가한다
                let event_list = [...this.state.event_list]
                event_list[event_idx].content_list[content_idx].kdeal_org_img_seq = res.data["kdeal_org_img_seq"];
                event_list[event_idx].content_list[content_idx].img_name = files[0].name;
                let tmp_event_list = [...this.state.tmp_event_list]
                tmp_event_list[event_idx].content_list[content_idx].kdeal_org_img_seq = res.data["kdeal_org_img_seq"];
                tmp_event_list[event_idx].content_list[content_idx].img_name = files[0].name;
                //console.log("uploadOrgImg event_list",event_list)
                if (res.data != null && res.data != '') {
                    this.setState({
                        event_list: event_list,
                        tmp_event_list: tmp_event_list,
                    }, () => {
                        // iframe 대신 사진만을 보여주기 위해 img를 사용하는 경우, img영역에 해당 사진을 띄운다
                        if(image_id == "detail_info_image"){
                            $("#"+this.state.tmp_event_list[event_idx].tmp_event_seq+"_image_viewer").attr("src",images[0]);
                        }
                        // 미리보기 데이터 저장
                        this.onChangeEventFormContent(event_idx);
                    });

                }
            })
            .catch(error => {
             });
        }, error => {
            console.error(error);
        });
    }

    // 이미지 업로드 팝업 : 파일첨부 열기
    handleClickBtnFileUpload(e, tmp_event_seq){ 
        e.preventDefault ();
        $("#"+tmp_event_seq+"_file_input").click();	
    };

    // 이미지 업로드 팝업 : 업로드 이벤트
    _handleImageChange = (e, event_idx, content_idx, image_id) => {
        this.uploadOrgImg(e.target.files, event_idx, content_idx, image_id);
    };

    // 이미지 삭제
    onClickRemoveImg(event_idx, content_idx){
        // 이미지가 삭제된 정보를 event_list, tmp_event_list 모두에 반영한다
        let event_list = [...this.state.event_list];
        event_list[event_idx].content_list[content_idx].img_name = null;
        event_list[event_idx].content_list[content_idx].org_img_seq = null;
        event_list[event_idx].content_list[content_idx].kdeal_org_img_seq = null;

        let tmp_event_list = [...this.state.tmp_event_list];
        tmp_event_list[event_idx].content_list[content_idx].img_name = null;
        tmp_event_list[event_idx].content_list[content_idx].org_img_seq = null;
        tmp_event_list[event_idx].content_list[content_idx].kdeal_org_img_seq = null;

        this.setState({
            event_list: event_list,
            tmp_event_list: tmp_event_list,
        }, () => {
            // 미리보기 데이터 저장
            this.onChangeEventFormContent(event_idx);
        });
    }

    // textarea 내용 변경시
    onKeyUpTextarea = (e, event_idx, content_idx, input_type_cd) => {

        // input_type_cd에 따라 입력 가능한 문자를 체크
        if(input_type_cd == "04002"){
            let check = /^[0-9\n]+$/; // 숫자만 입력되는지 체크
            if(!(check.test(e.target.value) || "" == e.target.value)){
                return false;
            }
        }
        // 텍스트 변경사항을 event_list, tmp_event_list 모두에 반영한다
        let event_list = [...this.state.event_list];
        let tmp_event_list = [...this.state.tmp_event_list];
        
        event_list[event_idx].content_list[content_idx].contents = e.target.value;
        tmp_event_list[event_idx].content_list[content_idx].contents = e.target.value;

        this.setState({
            event_list : event_list,
            tmp_event_list : tmp_event_list,
        }, () => {
            // iframe 연결끊기 : 로딩 되는것처럼 보이게 하는 부분
            $("#"+this.state.tmp_event_list[event_idx].tmp_event_seq+"_sosang_image_object_area").attr('src', "");

            // textareaTimer의 동작을 취소한다 (시간이 300 만큼 지나기 전에 입력이 또 있었다면, 이전의 timeout동작은 실행되지 않을것이다)
            clearTimeout(textareaTimer[event_idx+"/"+content_idx]);
            textareaTimer[event_idx+"/"+content_idx] = setTimeout(() => {
                // 미리보기 데이터 저장
                this.onChangeEventFormContent(event_idx);
            },300);

            // textarea와 object 높이 변경
            this.resizeHeight(e,event_idx);
        })
    }

    // textarea와 object 높이 변경
    resizeHeight(e,event_idx, event_target_id) {
        let target_id;
        if(e != null){ // textarea 내용 변경시
            target_id = e.target.id;
        } else{ // 순서변경 또는 추가 등 이벤트를 타지 않고 함수를 실행하는 경우
            target_id = event_target_id;
        }
        
        // 입력한 textarea 높이 변경
        StyleUtil.textareaHeightAuto(target_id,3);

        // object 길이
        const areaHeight= $("#"+this.state.tmp_event_list[event_idx].tmp_event_seq+"_area").innerHeight();
        $("#"+this.state.tmp_event_list[event_idx].tmp_event_seq+"_object").css('max-height',areaHeight);
    }

    // textarea와 object 높이 리셋
    resetHeight(event_idx, template_idx) {
        const {template_form_list} = this.state;
        
        // 입력한 textarea 높이 변경 : 컨텐츠가 텍스트인것만 실행
        if(template_form_list[template_idx].text_use_yn == "Y"){
            for (let cd_idx=0; cd_idx<template_form_list[template_idx]["contentDesignTemplateList"].length; cd_idx++) {
                if(template_form_list[template_idx]["contentDesignTemplateList"][cd_idx].content_type_cd == "44001"){
                    StyleUtil.textareaHeightAuto(this.state.tmp_event_list[event_idx].tmp_event_seq+"_"+(cd_idx+1)+"_textarea",3);
                }
            }
        }

        // object 길이
        const areaHeight= $("#"+this.state.tmp_event_list[event_idx].tmp_event_seq+"_area").innerHeight();
        $("#"+this.state.tmp_event_list[event_idx].tmp_event_seq+"_object").css('max-height',areaHeight);
    }

    // textarea와 object 높이 초기화
    initHeight(e, event_idx) {
        // 입력한 textarea 높이 변경
        StyleUtil.textareaHeightAuto(e.target.id,3);

        // object 길이
        const areaHeight= $("#"+this.state.tmp_event_list[event_idx].tmp_event_seq+"_area").innerHeight();
        $("#"+this.state.tmp_event_list[event_idx].tmp_event_seq+"_object").css('max-height',areaHeight);
    }

    // 이벤트 폼의 내용이 변경되었을 경우
    onChangeEventFormContent(event_idx){
        const content_list = this.state.tmp_event_list[event_idx].content_list;
        let tmp_event_seq = this.state.tmp_event_seq_list[event_idx];
        let event_type_cd = this.state.event_list[event_idx].event_type_cd;
        let background_color = this.state.event_list[event_idx].background_color;
        let kdeal_secure_product_token =this.state.kdeal_secure_product_token;

        // 미리보기용 데이터 저장
        const config = {
            headers: {
                'Content-Type': 'application/json',
                },
        };
        const url = '/rest/common/kdeal/content/event/tmp/save';
        const body = {
            content_list : content_list,
            tmp_event_seq : tmp_event_seq,
            event_type_cd : event_type_cd,
            background_color : background_color,
            kdeal_secure_product_token : kdeal_secure_product_token,
            product_no : "-1",
        }
        http
        .post(url, body, config)
		.then(res => {
			if (res.data != null && res.data != '') {
                // tmp_event_list에 content_seq 추가
                for(let content_idx in res.data.content_list) {
                    content_list[content_idx].content_seq = res.data.content_list[content_idx].content_seq;
                }
                let tmp_event_list  = this.state.tmp_event_list;
                tmp_event_list[event_idx].content_list = content_list
                this.setState({
                    tmp_event_list: tmp_event_list,
                });

                // iframe 재로딩
                $("#"+this.state.tmp_event_list[event_idx].tmp_event_seq+"_sosang_image_object_area").attr('src',object_domain+"/robomd_product_detail_v3.html?view_type_cd=0&product_no="+this.state.tmp_product_no+"&tmp_event_seq="+this.state.tmp_event_list[event_idx].tmp_event_seq+"&token=");
			}
		})
		.catch(error => {
		 });
    }

    // 폼 순서 변경 이벤트
    onClickFormOrderChange(event_num, change_event_num, type){
        let {event_list} = this.state;
        let {tmp_event_list} = this.state;
        let {tmp_event_seq_list} = this.state;
        
        // event_list, tmp_event_list에서 순서가 변경될 event를 뺀 후, 위치에 맞게 다시 넣는다
        // tmp_event_seq_list도 event가 이동함과 같이 변경한다
        if(type == "up"){
            const event = event_list.splice(event_num, 1);
            event_list.splice(change_event_num, 0, event[0]);
            const tmp_event = tmp_event_list.splice(event_num, 1);
            tmp_event_list.splice(change_event_num, 0, tmp_event[0]);
            const tmp_event_seq = tmp_event_seq_list.splice(event_num, 1);
            tmp_event_seq_list.splice(change_event_num, 0, tmp_event_seq[0]);
        } else if(type == "down"){
            const event = event_list.splice(event_num, 1);
            event_list.splice(change_event_num, 0, event[0]);
            const tmp_event = tmp_event_list.splice(event_num, 1);
            tmp_event_list.splice(change_event_num, 0, tmp_event[0]);
            const tmp_event_seq = tmp_event_seq_list.splice(event_num, 1);
            tmp_event_seq_list.splice(change_event_num, 0, tmp_event_seq[0]);
        }
        
        this.setState({
            event_list: event_list,
            tmp_event_list: tmp_event_list,
            tmp_event_seq_list: tmp_event_seq_list,
        }, ()=>{
            let min_idx = event_num  > change_event_num ? change_event_num : event_num;
            let max_idx = event_num  > change_event_num ? event_num : change_event_num;
            // 순서가 바뀐 위치 사이의 삭제되지 않은 event의 iframe을 재로딩하고 textarea와 iframe의 높이를 재설정한다
            for(var idx=min_idx;idx<max_idx+1;idx++){
                // 이벤트가 삭제된 것이 아니라면, iframe을 재로딩하고 textarea와 iframe의 높이를 재설정한다
                if(event_list[idx]["del_yn"] != "Y"){
                    $("#"+this.state.tmp_event_list[idx].tmp_event_seq+"_sosang_image_object_area").attr('src',object_domain+"/robomd_product_detail_v3.html?view_type_cd=0&product_no="+this.state.tmp_product_no+"&tmp_event_seq="+this.state.tmp_event_list[idx].tmp_event_seq+"&token=");
                    // 이벤트의 템플릿을 조회
                    const {template_form_list} = this.state;
                    let template_idx;
                    for(var i=0; i<template_form_list.length; i++){
                        if(template_form_list[i]["event_type_cd"] == event_list[idx]["event_type_cd"]){
                            template_idx = i;
                        }
                    }
                    // 입력한 textarea 높이 변경 : 컨텐츠가 텍스트인것만 실행
                    if(template_form_list[template_idx].text_use_yn == "Y"){
                        for (let cd_idx=0; cd_idx<template_form_list[template_idx]["contentDesignTemplateList"].length; cd_idx++) {
                            if(template_form_list[template_idx]["contentDesignTemplateList"][cd_idx].content_type_cd == "44001"){
                                this.resizeHeight(null, idx, this.state.tmp_event_list[idx].tmp_event_seq+"_"+(cd_idx+1)+"_textarea");
                            }
                        }
                    }
                }
            }
            
            // 폼에 포커싱 맞추기
            $("#"+this.state.tmp_event_list[change_event_num].tmp_event_seq+"_1_textarea").focus();
            $(':focus').blur();
        });
    }

    // 이벤트 개수 변경(+, - 버튼 클릭)
    EventNumChange(event_num, event_type_cd, type){
        let {event_list} = this.state;
        let {tmp_event_list} = this.state;
        let {tmp_event_seq_list} = this.state;
        let {template_form_list} = this.state;
        let template_idx;
        
        // 활성화된 이벤트의 디자인 템플릿 idx를 찾는다
        for(let idx in template_form_list) {
            if (template_form_list[idx].event_type_cd == event_type_cd) {
                template_idx = idx;
            }
        }

        if(type == "plus"){
            // 추가될 이벤트를 만든다
            let form_type_cd = template_form_list[template_idx].form_type_cd;
            let new_event = {
                form_type_cd : form_type_cd,
                // +버튼이 눌린 event와 같은 형식이니, 해당 event의 event_type_cd를 넣어 만든다
                event_type_cd: event_type_cd,
                event_seq : null,
                tmp_event_seq: tmp_event_seq_list[event_num+1], // 새로 발급받은 tmp_event_seq
                background_color: template_form_list[template_idx].background_color,
                content_list: [],
            };
            for(let cd_idx=0; cd_idx < template_form_list[template_idx]["contentDesignTemplateList"].length; cd_idx++) {
                if(template_form_list[template_idx]["contentDesignTemplateList"][cd_idx].content_type_cd == "44001"){
                    new_event["content_list"].push({
                            contents : "",
                            content_seq : null,
                            content_type_cd: template_form_list[template_idx]["contentDesignTemplateList"][cd_idx].content_type_cd,
                            font_color: template_form_list[template_idx]["contentDesignTemplateList"][cd_idx].text_color,
                            content_title_cd : template_form_list[template_idx]["contentDesignTemplateList"][cd_idx].content_title_cd,
                    });
                } else if(template_form_list[template_idx]["contentDesignTemplateList"][cd_idx].content_type_cd == "44002"){
                    new_event["content_list"].push({
                        kdeal_org_img_seq : null,
                        img_name: null,
                        content_seq : null,
                        content_type_cd: template_form_list[template_idx]["contentDesignTemplateList"][cd_idx].content_type_cd,
                        content_title_cd : template_form_list[template_idx]["contentDesignTemplateList"][cd_idx].content_title_cd,
                });
                }
            }
            // 이벤트가 추가되었으니, template_form_list의 cnt의 개수를 증가시킨다
            for(let idx in template_form_list) {
                if (template_form_list[idx].form_type_cd == form_type_cd) {
                    if (template_form_list[idx].event_type_cd == event_type_cd) {
                        template_form_list[idx]["form_cnt"] ++;
                    }
                    template_form_list[idx]["form_total_cnt"]++;
                }
            }
            // 위치에 맞게 이벤트를 추가한다
            event_list.splice(event_num+1, 0, JSON.parse(JSON.stringify(new_event)));
            tmp_event_list.splice(event_num+1, 0, JSON.parse(JSON.stringify(new_event)));

        } else if(type == "minus"){
            // 이벤트 제거는 리스트에서 빼는것이 아닌, del_yn값을 Y로 주는 방식을 사용한다
            event_list[event_num]["del_yn"] = "Y";
            tmp_event_list[event_num]["del_yn"] = "Y";
        }

        this.setState({
            event_list: event_list,
            tmp_event_list: tmp_event_list,
            template_form_list: template_form_list,
        }, ()=> {

            const {event_list, tmp_event_list, template_form_list} = this.state;
            for(var idx=event_num+1;idx<event_list.length;idx++){
                // 이벤트가 삭제된 것이 아니라면, iframe을 재로딩하고 textarea와 iframe의 높이를 재설정한다
                if(event_list[idx]["del_yn"] != "Y"){
                    $("#"+tmp_event_list[idx].tmp_event_seq+"_sosang_image_object_area").attr('src',object_domain+"/robomd_product_detail_v3.html?view_type_cd=0&product_no="+this.state.tmp_product_no+"&tmp_event_seq="+tmp_event_list[idx].tmp_event_seq+"&token=");
                    // resetHeight에서 템플릿의 textarea 영역 개수에 맞게 반복문을 돌려 높이를 지정하기 때문에 해당 event의 template을 조회해야 한다
                    for(let idx2=0;idx2<template_form_list.length;idx2++){
                        if(event_list[idx].form_type_cd == template_form_list[idx2].form_type_cd && event_list[idx].event_type_cd == template_form_list[idx2].event_type_cd){
                            this.resetHeight(idx,idx2);
                            break;
                        }
                    }
                }
            }
            
            if(type == "plus"){
                // 미리보기 데이터 저장
                this.onChangeEventFormContent(event_num+1);
                
                // 폼에 포커싱 맞추기
                $("#"+tmp_event_list[event_num+1].tmp_event_seq+"_1_textarea").focus();
                $(':focus').blur();
            }
        });
    }

    // event_form 순서이동을 위한 검사
    checkMoveEvent(event_num, type){
        const {event_list} = this.state;
        // 현재 event의 위쪽 이벤트로 del_yn이 아닌 evnet를 찾는다
        if(type=="up"){
            for(var i=event_num-1;i>=0;i--){
                if(event_list[i]["del_yn"] != "Y"){
                    return i;
                }
            }
        } else if(type=="down"){
            // 현재 event의 아래쪽 이벤트로 del_yn이 아닌 evnet를 찾는다
            for(var i=event_num+1;i<event_list.length;i++){
                if(event_list[i]["del_yn"] != "Y"){
                    return i;
                }
            }
        }
        return -1;
    }

    // 저장 버튼 클릭
    onClickSaveForm(){
        if (this.state.product_name == null || this.state.product_name.replace(" ", "").length == 0) {
            alert("상품명을 입력해 주세요.");
            $("#product_name").focus();
            return false;
        }
        if (this.state.kdeal_user_no == null || this.state.kdeal_user_no == "") {
            alert("업체명을 선택해 주세요.");
            $("#kdeal_user_no").focus();
            return false;
        }
        if (this.state.parent_event_type_cd == null || this.state.parent_event_type_cd == "") {
            alert("템플릿을 선택해 주세요.");
            $("#parent_event_type_cd").focus();
            return false;
        }

        // 비밀번호 검사 : 숫자와 문자가 들어있는지 확인 + 6~25의 자리수인지 확인
        const check_pw =/^(?=.*[a-zA-z])(?=.*[0-9]).{6,25}$/;
        // 소문자와 숫자만 사용되었는지 확인
        var check_pw2 = /^[a-z0-9]*$/;
        if (!(check_pw.test(this.state.pwd) && check_pw2.test(this.state.pwd))) {
            alert("영어 소문자와 숫자 조합 6자 이상 25자 이하의 비밀번호를 입력해주세요.");
            $("#input_password").focus();
            return false;
        }

        const config = {
            headers: {
                'Content-Type': 'application/json',
                },
        };
        const url = '/rest/common/kdeal/product/event/save';
        const body = {
            event_list : this.state.event_list,
            // null로 검사하기 때문에 ""로 보내면 수정으로 인식
            product_no : this.state.product_no != ""?  this.state.product_no : "-1",
            product_name : this.state.product_name != ""?  this.state.product_name : null,
            kdeal_user_no : this.state.kdeal_user_no != ""?  this.state.kdeal_user_no : null,
            parent_event_type_cd : this.state.parent_event_type_cd != ""?  this.state.parent_event_type_cd : null,
            pwd : this.state.product_no == ""?  this.state.pwd : null,
            kdeal_secure_product_token : this.state.product_no != "" ? this.state.kdeal_secure_product_token : null,
        }
        //console.log(JSON.stringify(body));
        http
        .post(url, body, config)
		.then(res => {
            //console.log(res.data);
			if (res.data != null && res.data != '') {

                this.setState({
                    product_no : res.data["product_no"],
                }, () => {
                    // 처음 저장하는 경우 주소값에 product_no 정보를 추가한다
                    if(StringUtil.getUrlParams("product_no") == null || StringUtil.getUrlParams("product_no") == ""){
                        window.history.replaceState("","",window.location.href+"?product_no="+this.state.product_no);
                    }
                    alert("저장하였습니다.");
                    window.location.reload();
                });
			}
		})
		.catch(error => {
		 });
    }

    // 취소 버튼 클릭
    onClickCancelBtn(){
        $("#detail_info_image").attr("src","");
        if (!window.confirm("작업 내용을 취소 하시겠습니까?")) {
            return false;
        }

        window.location.reload();
    }

    // 이미지 다운로드
    contentDownload() {
        this.setState({
            is_downloaded: false,
        })
        const config = {
            headers: {
                'content-type': 'application/json;'
            },
            //responseType: 'arraybuffer'
        }
        http.post("/rest/common/kdeal/content/capture",
            {
                "product_no" : this.state.tmp_product_no,
                "banner_width": "960",
                "view_type_cd" : "1"
            },
            config
        )
        .then(res => {
            this.setState({
                is_downloaded: true,
            })
            if (res.data.code == "200") {
                // 성공시 s3 파일 다운로드 요청
                this.fn_s3ImageFileDownload(res.data.capture_code, this.state.product_name);
            } else {
                alert(res.data.code + "\n" + res.data.msg);
            }
        })
        .catch(error => {
            //console.log (error);
            this.setState({
                is_downloaded: false,
            })
        });
    }

    // s3 이미지 다운로드
    fn_s3ImageFileDownload(capture_code, product_name) {
        // 파일 확장자 추출
        let file_type = capture_code.substring(capture_code.lastIndexOf(".")+1, capture_code.length);
        const config = {
            headers: {
                'content-type': 'application/json;'
            },
            responseType: 'arraybuffer'
        }
        http.post("/rest/common/kdeal/content/download",
            {
                "capture_code" : capture_code,
                "file_type" : file_type
            },
            config
        )
        .then(res => {
            if (res.data != null) {
                // 상품명(제목) 미입력시 '제목없음'로 다운로드
                if (product_name == '') {
                    product_name = '제목없음';
                }
                let file_name = product_name + '.'+file_type;
                var blob = new Blob([res.data], { type: 'image/'+file_type });

                // 퍼센트 기호(%)가 포함되어 있으면서 올바른 퍼센트 인코딩이 아닌 경우 찾기
                const invalidPercentEncoding = /%(?![0-9A-Fa-f]{2})/;
                if (!invalidPercentEncoding.test(file_name)) {
                    file_name = decodeURI(file_name);
                }
                
                FileDownload(blob, file_name);
                
                //회원가입 페이지 이동
                this.props.history.replace(
                    {
                        pathname: `/common/registUser?service_type=01003`,
                    }
                )
            } else {
                alert("s3 이미지 다운로드 요청 실패\n고객센터 : 1599-3518");
            }
        })
        .catch(error => {
            alert("s3 이미지 다운로드 요청 실패\n고객센터 : 1599-3518");
        });
    }

    // 상품 임시 저장(캡처 전에 실행하지만 현재 사용되지 않음)
    saveTmpEventList(){
        const config = {
            headers: {
                'content-type': 'application/json;'
            },
        }
        const body = {
            event_list : this.state.event_list,
            product_no : this.state.tmp_product_no,
            kdeal_secure_product_token : this.state.kdeal_secure_product_token,
        }
        http.post("/rest/common/kdeal/product/event/save/tmp",
            body,
            config
        )
        .then(res => {
            // this.contentDownload();
        })
        .catch(error => {
        });
    }

    // 컬러 변경 팔레트 열기
    onClickColorBox(event_idx, content_idx){
        const {displayColorPicker} = this.state;
        if(content_idx == null){
            displayColorPicker[event_idx] = true;
        } else{
            displayColorPicker[event_idx+"/"+content_idx] = true;
        }
        this.setState({
            displayColorPicker : displayColorPicker,
        }, () => {
            $("#palleteBack").show();
        });
    }

    // 컬러 변경 팔레트 닫기
    onClosePaletteArea(){
        this.setState({
            displayColorPicker : {},
        }, () => {
            $("#palleteBack").hide();
        });
    }

    // 이벤트 배경색 변경 : onChagne(계속 변경중일 경우)
    onChangeEventBackgroundColor = (e, event_idx) => {
        // 컬러값 맨 앞에붙는 #을 제거한다
        let color = e.hex.substr(1);

        // 색상 변경사항을 event_list, tmp_event_list 모두에 반영한다
        const {event_list, tmp_event_list} = this.state;
        event_list[event_idx].background_color = color;
        tmp_event_list[event_idx].background_color = color;

        this.setState({
            event_list : event_list,
            tmp_event_list : tmp_event_list,
        });
    }

    // 이벤트 배경색 변경 : onChangeComplete(마우스의 움직임이 멈췄을 경우)
    // 변경이 끝났을 때만, onChangeEventFormContent()를 실행한다
    onChangeEventBackgroundColorComplete = (e, event_idx) => {
        // 컬러값 맨 앞에붙는 #을 제거한다
        let color = e.hex.substr(1);

        // 색상 변경사항을 event_list, tmp_event_list 모두에 반영한다
        const {event_list, tmp_event_list} = this.state;
        event_list[event_idx].background_color = color;
        tmp_event_list[event_idx].background_color = color;

        this.setState({
            event_list : event_list,
            tmp_event_list : tmp_event_list,
        }, () => {
            // 미리보기 데이터 저장
            this.onChangeEventFormContent(event_idx);
        });
    }

    // 내용 글자색 변경 : onChagne(계속 변경중일 경우)
    onChangeContentColor = (e,event_idx, content_idx) => {
        // 컬러값 맨 앞에붙는 #을 제거한다
        let color = e.hex.substr(1);

        // 색상 변경사항을 event_list, tmp_event_list 모두에 반영한다
        const {event_list, tmp_event_list} = this.state;
        event_list[event_idx].content_list[content_idx].font_color = color;
        tmp_event_list[event_idx].content_list[content_idx].font_color = color;
        
        this.setState({
            event_list : event_list,
            tmp_event_list : tmp_event_list,
        });
    }

    // 내용 글자색 변경 : onChangeComplete(마우스의 움직임이 멈췄을 경우)
    // 변경이 끝났을 때만, onChangeEventFormContent()를 실행한다
    onChangeContentColorComplete = (e,event_idx, content_idx) => {
        // 컬러값 맨 앞에붙는 #을 제거한다
        let color = e.hex.substr(1);

        // 색상 변경사항을 event_list, tmp_event_list 모두에 반영한다
        const {event_list, tmp_event_list} = this.state;
        event_list[event_idx].content_list[content_idx].font_color = color;
        tmp_event_list[event_idx].content_list[content_idx].font_color = color;
        
        this.setState({
            event_list : event_list,
            tmp_event_list : tmp_event_list,
        }, () => {
            // 미리보기 데이터 저장
            this.onChangeEventFormContent(event_idx);
        });
    }
    

    render() {
        let sosang_form_and_reselt = []; // 폼 영역 html 태그 array
        // 템플릿을 조회한 후에 실행해야함
        if (this.state.template_form_list != null && this.state.template_form_list.length > 0) {
            let form_type_no = {} // 현재 그려진 각 form_type의 개수를 담고있는 객체
            let show_event_idx = 0; // 화면에 실제로 그려진 이벤트 개수 
            
            for(let event_idx=0; event_idx<this.state.event_list.length;event_idx++) { // event_list 만큼 loop 실행
                let event = this.state.event_list[event_idx];
                let template;
                for(let idx=0;idx<this.state.template_form_list.length;idx++){
                    if(event.form_type_cd == this.state.template_form_list[idx].form_type_cd && event.event_type_cd == this.state.template_form_list[idx].event_type_cd){
                        template = this.state.template_form_list[idx];
                    }
                }
                
                // 만약 해당 form_type_cd의 form_type_num이 비어있다면, 1로 초기화 시킨다.
                if(form_type_no[event.form_type_cd]==null ||form_type_no[event.form_type_cd] == ""){
                    form_type_no[event.form_type_cd] = 1;
                }
                let form_no = form_type_no[event.form_type_cd];

                let text_array = []; // textarea와 input에 넣을 텍스트 array
                if (this.state.event_list[event_idx] != null && this.state.event_list[event_idx].content_list != null && this.state.event_list[event_idx].content_list.length >= 1) {
                    // event_list의 content_list의 length가 1보다 큰 경우
                    for(let content_idx in this.state.event_list[event_idx].content_list) {
                        if (this.state.event_list[event_idx].content_list[content_idx].content_type_cd == "44002") { // 이미지 영역인 경우
                            text_array.push(this.state.event_list[event_idx].content_list[content_idx].img_name)
                        } else { // 그 외는 텍스트 영역
                            text_array.push(this.state.event_list[event_idx].content_list[content_idx].contents)
                        }
                    }
                }

                // content를 이벤트 템플릿에 맞게 동적으로 채워주는 부분
                let cd_list = [];
                for(let cd_idx=0; cd_idx < template["contentDesignTemplateList"].length; cd_idx++) {
                    cd_list.push(
                        template["contentDesignTemplateList"][cd_idx].content_type_cd == "44001" && template.text_use_yn == "Y"
                        ?
                        <div className="sosang_form_line_area">
                            <h3 className="sosang_form_span_text">
                                {template["contentDesignTemplateList"][cd_idx].content_title}
                                {template["contentDesignTemplateList"][cd_idx].input_type_cd == "04002"? " (숫자)" : null}
                            </h3>
                            {this.state.displayColorPicker[event_idx+"/"+cd_idx]
                            ?<div>
                                <div class="sosang_form_content_color_box" style={{background : "#"+this.state.event_list[event_idx].content_list[cd_idx].font_color}}/>
                                <SketchPicker color={"#"+this.state.event_list[event_idx].content_list[cd_idx].font_color}
                                onChange={e => this.onChangeContentColor(e,event_idx, cd_idx)}
                                onChangeComplete={e => this.onChangeContentColorComplete(e,event_idx, cd_idx)} disableAlpha/>
                            </div>
                            :<div class="sosang_form_content_color_box" style={{background : "#"+this.state.event_list[event_idx].content_list[cd_idx].font_color}} onClick={() => this.onClickColorBox(event_idx,cd_idx)} />
                            }
                            <textarea id={this.state.tmp_event_list[event_idx].tmp_event_seq+"_"+(cd_idx+1)+"_textarea"} name="intro_first" className="sosang_form_textarea"
                            onChange={e => this.onKeyUpTextarea(e,event_idx, cd_idx, template["contentDesignTemplateList"][cd_idx].input_type_cd)} onBlur={e=>this.initHeight(e, event_idx)} value={text_array.length >= (cd_idx+1) && text_array[cd_idx] != null ? text_array[cd_idx] : ""} placeholder="내용을 입력해 주세요." />
                        </div>
                        : template["contentDesignTemplateList"][cd_idx].content_type_cd == "44002" && template.image_use_yn == "Y"
                        ?
                        <>
                            <h3 className="sosang_form_span_text">{template["contentDesignTemplateList"][cd_idx].content_title}</h3>
                            <div className="sosang_form_line_area">
                                <input type="file" id={this.state.tmp_event_list[event_idx].tmp_event_seq+"_file_input"} onChange={e => this._handleImageChange(e,event_idx, cd_idx, "")} accept="image/jpg,image/png,image/jpeg,image/gif,image/bmp,image/tiff" value="" style={{display:"none"}} tabindex="-1"></input>
                                <button className="sosang_select_file_btn" onClick={e => this.handleClickBtnFileUpload(e, this.state.tmp_event_list[event_idx].tmp_event_seq)}>파일 선택</button>
                                <input className="sosang_select_file_input" id={this.state.tmp_event_list[event_idx].tmp_event_seq+"_image_name"} placeholder="파일을 선택해 주세요." value={text_array.length >= (cd_idx+1) && text_array[cd_idx] != null ? text_array[cd_idx] : ""} readOnly tabindex="-1" style={{marginLeft:"0px", marginTop:"0px"}}></input>
                                {text_array.length >= (cd_idx+1) && text_array[cd_idx] != null
                                ?<svg className="sosang_select_file_input_x_btn" onClick={() => {this.onClickRemoveImg(event_idx, cd_idx)}} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 0.875C7.39303 0.875 5.82214 1.35152 4.486 2.24431C3.14985 3.1371 2.10844 4.40605 1.49348 5.8907C0.87852 7.37535 0.717618 9.00901 1.03112 10.5851C1.34463 12.1612 2.11846 13.6089 3.25476 14.7452C4.39106 15.8815 5.8388 16.6554 7.4149 16.9689C8.99099 17.2824 10.6247 17.1215 12.1093 16.5065C13.594 15.8916 14.8629 14.8502 15.7557 13.514C16.6485 12.1779 17.125 10.607 17.125 9C17.1209 6.84638 16.2635 4.78216 14.7407 3.25932C13.2178 1.73648 11.1536 0.87913 9 0.875ZM11.9453 11.0547C12.0627 11.1732 12.1285 11.3332 12.1285 11.5C12.1285 11.6668 12.0627 11.8268 11.9453 11.9453C11.8259 12.0608 11.6662 12.1254 11.5 12.1254C11.3338 12.1254 11.1742 12.0608 11.0547 11.9453L9 9.88281L6.94532 11.9453C6.82585 12.0608 6.66618 12.1254 6.5 12.1254C6.33383 12.1254 6.17415 12.0608 6.05469 11.9453C5.93733 11.8268 5.87149 11.6668 5.87149 11.5C5.87149 11.3332 5.93733 11.1732 6.05469 11.0547L8.11719 9L6.05469 6.94531C5.95503 6.82388 5.90409 6.66971 5.9118 6.51281C5.91951 6.3559 5.9853 6.20747 6.09639 6.09638C6.20747 5.9853 6.3559 5.9195 6.51281 5.9118C6.66972 5.90409 6.82388 5.95502 6.94532 6.05469L9 8.11719L11.0547 6.05469C11.1761 5.95502 11.3303 5.90409 11.4872 5.9118C11.6441 5.9195 11.7925 5.9853 11.9036 6.09638C12.0147 6.20747 12.0805 6.3559 12.0882 6.51281C12.0959 6.66971 12.045 6.82388 11.9453 6.94531L9.88282 9L11.9453 11.0547Z" fill="#D1D1D1"/>
                                </svg>
                                :""}
                            </div>
                        </>
                        :''
                    )
                }
                cd_list.push(<div style={{marginBottom:"32px"}}></div>); // 마지막 컨텐츠 아래로 이벤트 여백 생성

                let event_num = event_idx;
                let obj = template;

                if(this.state.event_list[event_num]["del_yn"] != "Y"){
                    sosang_form_and_reselt.push(
                        <div>
                            <div className="sosang_event_description">{(show_event_idx+1)+". "+obj.description}</div>
                            <div className="sosang_form_and_reselt">
                                <div className="sosang_up_down_btn_area">
                                    {this.checkMoveEvent(event_num, "up") != -1
                                    ?<img src={btn_arrow_up_img} onClick={() => this.onClickFormOrderChange(event_num, this.checkMoveEvent(event_num, "up"), "up")} style={{marginBottom: "15px",cursor: "pointer"}} />
                                    :<div style={{marginLeft: "28px"}}></div>}
                                    {this.checkMoveEvent(event_num, "down") != -1
                                    ?<img src={btn_arrow_down_img} onClick={() => this.onClickFormOrderChange(event_num, this.checkMoveEvent(event_num, "down"), "down")} style={{cursor: "pointer"}} />
                                    :""}
                                </div>
                                <div id={this.state.tmp_event_list[event_num].tmp_event_seq+"_area"} className="sosang_form_area">
                                    <div className="sosang_form_title_area">
                                        <h2 className="sosang_form_title_text">{obj.form_title}{obj.form_total_cnt > 1?" "+form_no:""}</h2>
                                        {this.state.displayColorPicker[event_num]
                                        ?<div>
                                            <div class="sosang_form_event_color_box" style={{background : "#"+this.state.event_list[event_num].background_color}}/>
                                            <SketchPicker color={"#"+this.state.event_list[event_num].background_color}
                                            onChange={e => this.onChangeEventBackgroundColor(e,event_num)} 
                                            onChangeComplete={e => this.onChangeEventBackgroundColorComplete(e,event_num)} disableAlpha/>
                                        </div>
                                        :<div class="sosang_form_event_color_box" style={{background : "#"+this.state.event_list[event_num].background_color}} onClick={() => this.onClickColorBox(event_num)} />
                                        }
                                        <div className="sosang_plus_area">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => {this.loadTmpEventSeqList(event_num,this.state.event_list[event_num].event_type_cd, "plus")}} style={{cursor: "pointer"}}>
                                                <path d="M21 12C21 12.1989 20.921 12.3897 20.7803 12.5303C20.6397 12.671 20.4489 12.75 20.25 12.75H12.75V20.25C12.75 20.4489 12.671 20.6397 12.5303 20.7803C12.3897 20.921 12.1989 21 12 21C11.8011 21 11.6103 20.921 11.4697 20.7803C11.329 20.6397 11.25 20.4489 11.25 20.25V12.75H3.75C3.55109 12.75 3.36032 12.671 3.21967 12.5303C3.07902 12.3897 3 12.1989 3 12C3 11.8011 3.07902 11.6103 3.21967 11.4697C3.36032 11.329 3.55109 11.25 3.75 11.25H11.25V3.75C11.25 3.55109 11.329 3.36032 11.4697 3.21967C11.6103 3.07902 11.8011 3 12 3C12.1989 3 12.3897 3.07902 12.5303 3.21967C12.671 3.36032 12.75 3.55109 12.75 3.75V11.25H20.25C20.4489 11.25 20.6397 11.329 20.7803 11.4697C20.921 11.6103 21 11.8011 21 12Z" fill="#646464"/>
                                            </svg>
                                            {form_no != 1
                                            ?<svg width="24" height="24" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => {this.EventNumChange(event_num,this.state.event_list[event_num].event_type_cd,"minus")}} style={{cursor: "pointer",marginLeft: "15px"}}>
                                                <path d="M16.875 10.625H3.125C2.95924 10.625 2.80027 10.5592 2.68306 10.4419C2.56585 10.3247 2.5 10.1658 2.5 10C2.5 9.83424 2.56585 9.67527 2.68306 9.55806C2.80027 9.44085 2.95924 9.375 3.125 9.375H16.875C17.0408 9.375 17.1997 9.44085 17.3169 9.55806C17.4342 9.67527 17.5 9.83424 17.5 10C17.5 10.1658 17.4342 10.3247 17.3169 10.4419C17.1997 10.5592 17.0408 10.625 16.875 10.625Z" fill="#646464"/>
                                            </svg>
                                            
                                            : ""
                                            }
                                        </div>
                                    </div>
                                    {cd_list}
                                </div>
                                {/* id="intro_image_object" */}
                                <div id={this.state.tmp_event_list[event_num].tmp_event_seq+"_object"} style={{position:"relative", width:"100%"}}>
                                    <iframe id={this.state.tmp_event_list[event_num].tmp_event_seq+"_sosang_image_object_area"} className="sosang_image_object_area" type="text/html" src={""} style={{position:"absolute", minHeight:"100%"}}>
                                    </iframe>
                                </div>
                            </div>
                        </div>
                    )
                    form_type_no[event.form_type_cd] ++;
                    show_event_idx ++;
                }
            }
        }
        return (
            <>
                <div id="sosang_page_area" class="style_guide_v2" style={{minHeight:"100%", background: "#FCFCFC"}}>
                    <div className="list_home_main" style={{width:"100vw", height:"60px",boxShadow:"rgb(0 0 0 / 5%) 0px 4px 15px", background: "#FFFFFF"}}>
                        <div style={{height:"100%", display:"flex", alignItems:"center"}}>
                            <a href="/kdeal/common/product/list">
                                <img src="https://s3.ap-northeast-2.amazonaws.com/otdeal.file/kdeal_logo.svg" alt="" style={{width:"100%",marginLeft: "-10px;"}}/>
                            </a>
                            <div style={{
                                marginLeft:"24px",
                                fontWeight: "500",
                                fontSize: "18px",
                                lineHeight: "26px"
                            }}>
                                <a href="/kdeal/common/product/list" style={{color:"#202020"}}> 소상공인 자료 등록 현황 </a>
                            </div>
                        </div>
                    </div>   
                    <input type="password" style={{width: "0px", padding:"0", border:"0", height: "0px", display:"none"}} autoComplete="new-password"></input>
                    <div id="admin_wrap" class="admin_wrap" style={{overflowX:"auto"}}>
                        <div class="admin_page" style={{padding:"0 0 0 0"}}>
                            {this.state.product_no == "" || this.state.kdeal_secure_product_token != ""
                            ?<div className="sosang_select_input_area" style={{marginTop:"50px"}}>
                                <div className="sosang_form_menu_text" style={{marginBottom:"10px"}}>상품명 (상세디자인명)</div>
                                <input type="text" style={{width: "300px", padding:"0 30px 0 15px" , height: "42px", marginBottom:"20px", marginRight: "115px"}} 
                                className="" id="product_name" placeholder="상품명을 입력해 주세요." value={this.state.product_name} autoComplete="off"
                                onChange={(e) => {
                                    this.setState({
                                        product_name: e.target.value
                                    })
                                }}></input>
                            </div>
                            :""}
                            {
                                this.state.product_no != "" && this.state.kdeal_secure_product_token == ""
                                ? <div style={{marginLeft:"115px", marginTop:"50px", width: "315px"}}>
                                    <div style={{color:"#10CFC9", fontWeight:"600"}}>작성자만 글을 수정할 수 있습니다.</div>
                                    <div>글 수정을 하시려면 업체명과 비밀번호를 입력해 주세요.</div>
                                  </div>
                                :""
                            }
                            <div className="sosang_select_input_area">
                                {this.state.product_no == "" || this.state.kdeal_secure_product_token != ""
                                ?   <div style={{display:"flex", flexWrap:"nowrap", marginBottom:"10px"}}>
                                        <div className="sosang_form_menu_text">업체명 (작성자)</div> 
                                        <div id="kdeal_user_no_select_error" style={{color:"#e7342c", marginLeft:"8px", lineHeight: "13.5px", display:"none"}}>(업체명을 선택해 주세요.)</div>
                                    </div>
                                :   <div style={{display:"flex", flexWrap:"nowrap", marginBottom:"10px", marginTop:"50px"}}>
                                        <div className="sosang_form_menu_text">업체명 (작성자)</div> 
                                        <div id="kdeal_user_no_select_error" style={{color:"#e7342c", marginLeft:"8px", lineHeight: "13.5px", display:"none"}}>(업체명을 선택해 주세요.)</div>
                                    </div>}
                                <div style={{position:"relative", height: "42px", marginBottom:"20px"}}>
                                    <input id="kdeal_user_nane" type="text" 
                                    style={{position:"absolute", left:"1px", width:"300px", height: "42px", padding:"0 30px 0 15px"}} 
                                    placeholder="업체명을 검색 후 선택해 주세요."
                                    value={this.state.kdeal_user_name}
                                    onChange={(e) => {
                                        if (e.target.value != null && e.target.value != "") {
                                            let kdeal_user_obj = this.state.shop_list.filter(obj => obj.corp_name_reg_no == e.target.value)
                                            // alert(JSON.stringify(kdeal_user_obj));
                                            let kdeal_user_no = ""
                                            if (kdeal_user_obj.length > 0) {
                                                kdeal_user_no = kdeal_user_obj[0].user_no
                                                $("#kdeal_user_nane").blur(); // 매칭되는 업체 있으면 포커스 아웃
                                            } else {
                                                kdeal_user_no = ""
                                            }
                                            this.setState({
                                                kdeal_user_name: e.target.value,
                                                kdeal_user_no: kdeal_user_no
                                            }, () => {
                                                // alert(this.state.kdeal_user_no);
                                                if(this.state.kdeal_user_no == null || this.state.kdeal_user_no == "") {
                                                    // $("#kdeal_user_no_select_error").show();
                                                } else {
                                                    $("#kdeal_user_no_select_error").hide();
                                                }
                                            })
                                        } else {
                                            this.setState({
                                                kdeal_user_name: e.target.value,
                                                kdeal_user_no: ""
                                            }, () => {
                                                // alert(this.state.kdeal_user_no);
                                                if(this.state.kdeal_user_no == null || this.state.kdeal_user_no == "") {
                                                    // $("#kdeal_user_no_select_error").show();
                                                } else {
                                                    $("#kdeal_user_no_select_error").hide();
                                                }
                                            })
                                        }
                                    }}
                                    onBlur={(e) => {
                                        if(this.state.kdeal_user_no == null || this.state.kdeal_user_no == "") {
                                            $("#kdeal_user_no_select_error").show();
                                        } else {
                                            $("#kdeal_user_no_select_error").hide();
                                        }
                                    }}
                                    autoComplete="off"
                                    list="kdeal_user_no">

                                    </input>
                                    <datalist id="kdeal_user_no" style={{width: "300px", height: "42px", padding:"0 30px 0 15px", fontSize: "14px", marginBottom:"20px", marginRight: "115px", color:"#999"}} value={this.state.kdeal_user_no}>
                                        <option value="" disabled>
                                            업체명을 선택해 주세요.
                                        </option>    
                                        {
                                            this.state.shop_list != null && this.state.shop_list.map((obj, idx) => (
                                                <option value= {obj.corp_name_reg_no}>
                                                    {/* {obj.corp_name_reg_no} */}
                                                </option>    
                                            ))
                                        }
                                    </datalist>
                                </div>
                            </div>
                            {this.state.product_no == "" || this.state.kdeal_secure_product_token != ""
                            ?<div className="sosang_select_input_area">
                                <div style={{display:"flex", flexWrap:"nowrap"}}>
                                    <div className="sosang_form_menu_text" style={{marginBottom:"10px"}}>템플릿</div> 
                                    <div style={{color:"#10CFC9", marginLeft:"8px", lineHeight: "13.5px"}}>{
                                        this.state.parent_event_type_cd == null || this.state.parent_event_type_cd == ""?"(템플릿을 먼저 선택해 주세요.)":""
                                    }</div>
                                </div>
                                {
                                    this.state.parent_event_type_cd == "" || this.state.parent_event_type_cd == null
                                    ? 
                                        <select id="parent_event_type_cd" style={{color:"#999"}} value={this.state.parent_event_type_cd} onChange={(e) => this.changeTemplate(e)}>
                                            <option value="" disabled>
                                                템플릿을 선택해 주세요.
                                            </option>    
                                            {
                                                this.state.template_code_list != null && this.state.template_code_list.map((obj, idx) => (
                                                    <option value={obj.code_cd}>
                                                        {obj.code_name}
                                                    </option>    
                                                ))
                                            }
                                        </select>
                                    :
                                        <select id="parent_event_type_cd" value={this.state.parent_event_type_cd} onChange={(e) => this.changeTemplate(e)}>
                                            <option value="" disabled>
                                                템플릿을 선택해 주세요.
                                            </option>    
                                            {
                                                this.state.template_code_list != null && this.state.template_code_list.map((obj, idx) => (
                                                    <option value={obj.code_cd}>
                                                        {obj.code_name}
                                                    </option>    
                                                ))
                                            }
                                        </select>
                                }
                                
                            </div>
                            :""}
                            <div className="sosang_select_input_area">
                                <div className="sosang_form_menu_text" style={{marginBottom:"10px"}}>비밀번호</div>
                                <input type="password" style={{width: "300px", padding:"0 30px 0 15px" , height: "42px", fontSize:"14px", marginRight: "115px"}} 
                                className="" id="input_password" placeholder="영어 소문자와 숫자 조합 6자 이상 25자 이하" value={this.state.pwd} autocomplete="off"
                                onChange={(e) => {
                                    // 영어 대소문자,숫자,특수문자 입력 가능
                                    var check_pw = /^[a-zA-Z\\d`~!@#$%^&*()-_=+]*$/;
                                    //var check_pw = /^[A-Za-z0-9]*$/;
                                    if(check_pw.test(e.target.value)){
                                        this.setState({
                                            pwd: e.target.value
                                        });
                                    }
                                }}
                                onKeyPress={(e) => {
                                    // 엔터 입력시 '확인'버튼 클릭
                                    if(e.key=='Enter'){
                                        $("#check_password_btn").click();	
                                    }
                                }}></input>
                            </div>
                            {this.state.product_no == null || this.state.product_no==""
                            ?<>
                                <div className="sosang_password_guide">* 글 수정 시 필요합니다. 반드시 기억해 주세요.</div>
                                <div style={{marginBottom:"50px"}}></div>
                            </>
                            :<>

                                <div style={{marginBottom:"50px"}}></div>
                            </>}
                            {this.state.product_no != "" && this.state.kdeal_secure_product_token == ""
                            ?<button id="check_password_btn" className="sosang_form_save_btn" style={{marginLeft:"115px", color:"#3A3A3A", width:"300px", marginRight: "115px"}} onClick={e => this.checkPassword()}>확인</button>
                            :""} 
                            {
                                this.state.parent_event_type_cd != ""
                                ?   <>
                                        <div className="sosang_form_and_reselt" style={{marginBotton:"24px", marginLeft:"115px"}}>
                                            <div className="sosang_form_menu_text" style={{width:"713px", marginRight:"40px"}}>내용 입력</div>
                                            <div className="sosang_form_menu_text">미리보기</div>
                                        </div>
                                        {sosang_form_and_reselt}
                                        <div id="footer_line" style={{border: "0.4px solid #ACACAC", minWidth:"1400px"}}></div>
                                        <div id="footer" style={{paddingTop:"32px", background:"#FFFFFF", minWidth:"1400px"}}>
                                            <div className="sosang_form_and_reselt" style={{marginLeft:"115px"}}>
                                                <button className="sosang_form_cancel_btn hover_white" style={{color:"#3A3A3A"}} onClick={e => this.onClickCancelBtn()}>취소</button>
                                                <button className="sosang_form_save_btn hover_mint" style={{marginRight:"784px", color:"#3A3A3A"}} onClick={e => this.onClickSaveForm()}>저장</button>
                                                {/* {
                                                    this.state.is_downloaded
                                                    ?
                                                        <button className="sosang_form_download_btn" onClick={e => this.saveTmpEventList()}>
                                                            <img src={download_img}/>&nbsp;이미지 다운로드
                                                        </button>
                                                    :
                                                        <button className="sosang_form_download_btn" style={{width:"155px"}}>
                                                            다운로드 중...
                                                        </button>
                                                } */}
                                            </div>
                                        </div>
                                    </>
                                :   <div style={{margin:"0 0 20px 0"}}>
                                        {/* 템플릿을 선택해 주세요. */}
                                    </div>
                            }
                        </div>
                    </div>

                    {/* 팔레트 배경 */}
                    <div id="palleteBack" style={{top: "0", left:"0", width:"100%", height:"100%", position:"fixed", display:"none", background:"#ffffff00"}} onClick={() => this.onClosePaletteArea()}></div> 
                </div>
            </>
        )
    };
    
}